module.exports = __webpack_public_path__ + "static/img/honor25.4c6a9ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor25.png
// module id = jdrR
// module chunks = 0